import { Component, Input } from "@angular/core";

@Component({
    selector: 'zbp-footer',
    template: '<div>Mock Footer Component</div>',
    standalone: false
})
export class MockFooterComponent {
  @Input() showLinks = true;
  @Input() isAndroidUser: boolean = false;
  @Input() background = 'bgPrimary';
  @Input() isEce = false;

  open(content) {
    return content;
  }

  getSystemRequirementsLink(): string {
    return 'mock-system-requirements-link';
  }

  getLegalLink() {
    return 'mock-legal-link';
  }

  getPrivacyLink() {
    return 'mock-privacy-link';
  }

  getTechSupportLink() {
    return 'mock-tech-support-link';
  }
}